import { render, staticRenderFns } from "./PunchItemForm.vue?vue&type=template&id=7746f896"
import script from "./PunchItemForm.vue?vue&type=script&lang=ts"
export * from "./PunchItemForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports